import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImportDummyDialog({ open, handleClose, handleImport }) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{'Import Sandbox Demo Data'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    Are you sure you want to import sandbox demo data?
                </DialogContentText>
                <br />
                <DialogContentText id="alert-dialog-slide-description2">
                    The sandbox demo data includes 100 synthetic cases to
                    provide the ability to test all features of Health Data
                    Explorer. <b>This data is not real world cases.</b>
                </DialogContentText>
                <br />
                <DialogContentText id="alert-dialog-slide-description2">
                    Please note that once imported, the data may take a few
                    minutes to reflect in the analytics and case views.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={handleImport}
                    variant={'contained'}
                    color={'primary'}
                >
                    Import
                </Button>
            </DialogActions>
        </Dialog>
    );
}
